import { SVGProps } from 'react'

export const MaestroBW = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="65"
      height="46"
      viewBox="0 0 65 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M37.1424 23.2362C37.1424 30.3086 31.5906 36.0418 24.7421 36.0418C17.8936 36.0418 12.3418 30.3086 12.3418 23.2362C12.3418 16.1639 17.8936 10.4307 24.7421 10.4307C31.5906 10.4307 37.1424 16.1639 37.1424 23.2362Z"
        fill="#323232"
      />
      <path
        d="M53.2293 23.2362C53.2293 30.3086 47.6775 36.0418 40.829 36.0418C33.9805 36.0418 28.4287 30.3086 28.4287 23.2362C28.4287 16.1639 33.9805 10.4307 40.829 10.4307C47.6775 10.4307 53.2293 16.1639 53.2293 23.2362Z"
        fill="#838383"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.786 32.9822C35.4522 30.6334 37.1428 27.1384 37.1428 23.2357C37.1428 19.333 35.4522 15.838 32.786 13.4893C30.1198 15.838 28.4292 19.333 28.4292 23.2357C28.4292 27.1384 30.1198 30.6334 32.786 32.9822Z"
        fill="#797979"
      />
    </svg>
  )
}
